var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-sheet",
    {
      ref: "container",
      staticClass: "grid-container container--fluid",
      class: { "grid-contailer__inited": _vm.isInitialized },
      attrs: { color: "#B5B5B5" },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.errorLoadingGrid,
              expression: "!errorLoadingGrid",
            },
          ],
          ref: "scene",
          staticClass: "scene",
        },
        [
          _vm.editable
            ? _c(
                "div",
                { staticClass: "params" },
                [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c(
                        "v-btn-toggle",
                        {
                          attrs: { dense: "", group: "" },
                          model: {
                            value: _vm.editMode,
                            callback: function ($$v) {
                              _vm.editMode = $$v
                            },
                            expression: "editMode",
                          },
                        },
                        [
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "v-size--small align-self-center mb-0 mt-1",
                              },
                              [_vm._v("Скважины")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-row v-btn-toggle v-btn-toggle--dense v-btn-toggle--group",
                              },
                              [
                                _c(
                                  "v-btn",
                                  { attrs: { value: "move" } },
                                  [_c("v-icon", [_vm._v("mdi-cursor-move")])],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  { attrs: { value: "add" } },
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-map-marker-plus"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  { attrs: { value: "delete" } },
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-map-marker-minus"),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  { attrs: { value: "edit" } },
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-map-marker-question"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("v-divider", { attrs: { vertical: "" } }),
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "v-size--small align-self-center mb-0 mt-1",
                              },
                              [_vm._v("Перетоки")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-row v-btn-toggle v-btn-toggle--dense v-btn-toggle--group",
                              },
                              [
                                _c(
                                  "v-btn",
                                  { attrs: { value: "connect" } },
                                  [_c("v-icon", [_vm._v("mdi-vector-line")])],
                                  1
                                ),
                                _c(
                                  "v-btn",
                                  { attrs: { value: "disconnect" } },
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-vector-polyline-minus"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("v-divider", { attrs: { vertical: "" } }),
                          _c("div", { staticClass: "d-flex flex-column" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "v-size--small align-self-center mb-0 mt-1",
                              },
                              [_vm._v("Инфо")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-row v-btn-toggle v-btn-toggle--dense v-btn-toggle--group",
                              },
                              [
                                _c(
                                  "v-btn",
                                  { attrs: { value: "cell" } },
                                  [
                                    _c("v-icon", [
                                      _vm._v("mdi-square-circle-outline"),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ],
                        1
                      ),
                      _c("v-divider", { attrs: { vertical: "" } }),
                      _vm.showExtraMenu
                        ? _c("div", { staticClass: "d-flex flex-column" }, [
                            _c(
                              "p",
                              {
                                staticClass:
                                  "v-size--small align-self-center mb-0 mt-1",
                              },
                              [_vm._v("Прочее")]
                            ),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex flex-row v-btn-toggle v-btn-toggle--dense v-btn-toggle--group",
                              },
                              [
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "offset-y": "",
                                      "close-on-content-click": false,
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function (ref) {
                                            var on = ref.on
                                            var attrs = ref.attrs
                                            return [
                                              _c(
                                                "v-btn",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      staticClass: "mx-2 mt-1",
                                                      attrs: { icon: "" },
                                                    },
                                                    "v-btn",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c("v-icon", [
                                                    _vm._v("mdi-plus"),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3272224208
                                    ),
                                  },
                                  [_vm._t("extraMenu")],
                                  2
                                ),
                              ],
                              1
                            ),
                          ])
                        : _vm._e(),
                      _vm.showExtraMenu
                        ? _c("v-divider", { attrs: { vertical: "" } })
                        : _vm._e(),
                      _c("v-spacer"),
                      _c(
                        "div",
                        { staticClass: "history-slider mt-1" },
                        [
                          _vm.injectionData && _vm.injectionData.t
                            ? _c("v-slider", {
                                attrs: {
                                  min: "0",
                                  max: _vm.injectionData.t.length - 1,
                                  step: "1",
                                  label: "История",
                                  hint: String(
                                    _vm.injectionData.t[_vm.historyIndex]
                                  ),
                                  "persistent-hint": "",
                                },
                                model: {
                                  value: _vm.historyIndex,
                                  callback: function ($$v) {
                                    _vm.historyIndex = $$v
                                  },
                                  expression: "historyIndex",
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-menu",
                        {
                          attrs: {
                            "offset-y": "",
                            "close-on-content-click": false,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function (ref) {
                                  var on = ref.on
                                  var attrs = ref.attrs
                                  return [
                                    _c(
                                      "v-btn",
                                      _vm._g(
                                        _vm._b(
                                          {
                                            staticClass: "ml-2 mt-1",
                                            attrs: { icon: "" },
                                          },
                                          "v-btn",
                                          attrs,
                                          false
                                        ),
                                        on
                                      ),
                                      [_c("v-icon", [_vm._v("mdi-cog")])],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1331890549
                          ),
                        },
                        [
                          _c(
                            "v-list",
                            [
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-switch", {
                                        staticClass: "mt-0",
                                        attrs: { "hide-details": "" },
                                        model: {
                                          value: _vm.showPlane,
                                          callback: function ($$v) {
                                            _vm.showPlane = $$v
                                          },
                                          expression: "showPlane",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-list-item-title", [_vm._v("Сетка")]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-switch", {
                                        staticClass: "mt-0",
                                        attrs: { "hide-details": "" },
                                        model: {
                                          value: _vm.showAxis,
                                          callback: function ($$v) {
                                            _vm.showAxis = $$v
                                          },
                                          expression: "showAxis",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-list-item-title", [_vm._v("Оси")]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-switch", {
                                        staticClass: "mt-0",
                                        attrs: { "hide-details": "" },
                                        model: {
                                          value: _vm.showMesh,
                                          callback: function ($$v) {
                                            _vm.showMesh = $$v
                                          },
                                          expression: "showMesh",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-list-item-title", [_vm._v("Пласт")]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-switch", {
                                        staticClass: "mt-0",
                                        attrs: { "hide-details": "" },
                                        model: {
                                          value: _vm.showConnectionsHeightDiff,
                                          callback: function ($$v) {
                                            _vm.showConnectionsHeightDiff = $$v
                                          },
                                          expression:
                                            "showConnectionsHeightDiff",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-list-item-title", [
                                    _vm._v("Разность высот перетоков"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                [
                                  _c(
                                    "v-list-item-icon",
                                    [
                                      _c("v-switch", {
                                        staticClass: "mt-0",
                                        attrs: { "hide-details": "" },
                                        model: {
                                          value: _vm.connectionsAutoload,
                                          callback: function ($$v) {
                                            _vm.connectionsAutoload = $$v
                                          },
                                          expression: "connectionsAutoload",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("v-list-item-title", [
                                    _vm._v("Автообновление соединений"),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "number",
                                      label: "Размер маркера",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.wellMarkerSize,
                                      callback: function ($$v) {
                                        _vm.wellMarkerSize = $$v
                                      },
                                      expression: "wellMarkerSize",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "number",
                                      label: "Размер шрифта",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.fontSize,
                                      callback: function ($$v) {
                                        _vm.fontSize = $$v
                                      },
                                      expression: "fontSize",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-list-item",
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "number",
                                      label: "Масштаб по Z",
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.zScaleRaw,
                                      callback: function ($$v) {
                                        _vm.zScaleRaw = $$v
                                      },
                                      expression: "zScaleRaw",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.showMesh
                                ? _c(
                                    "v-list-item",
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: "Цвет сетки",
                                          outlined: "",
                                          dense: "",
                                          "hide-details": "",
                                          "return-object": "",
                                          items: _vm.availableProperties,
                                        },
                                        model: {
                                          value: _vm.selectedProperty,
                                          callback: function ($$v) {
                                            _vm.selectedProperty = $$v
                                          },
                                          expression: "selectedProperty",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.editMode === "move"
                    ? _c(
                        "v-btn-toggle",
                        {
                          attrs: { dense: "", group: "", multiple: "" },
                          model: {
                            value: _vm.moveAxis,
                            callback: function ($$v) {
                              _vm.moveAxis = $$v
                            },
                            expression: "moveAxis",
                          },
                        },
                        [
                          _c("v-btn", { attrs: { value: "x" } }, [_vm._v("X")]),
                          _c("v-btn", { attrs: { value: "y" } }, [_vm._v("Y")]),
                          _c("v-btn", { attrs: { value: "z" } }, [_vm._v("Z")]),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm.isLoading || _vm.isProcessing || !_vm.isInitialized
        ? _c("v-progress-circular", {
            attrs: { color: "white", indeterminate: "", size: "64" },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }